const lightTheme = {
  name: 'light',
  token: {
    colorPrimary: '#454793',
    colorLink: '#454793',
  },
  components: {
    Button: {
      colorPrimary: '#454793',
      colorPrimaryHover: '#5a5ba8',
      colorPrimaryActive: '#3a3b7a',
      colorPrimaryText: '#ffffff',
      colorPrimaryBg: '#454793',
      colorPrimaryBorder: '#454793',
      colorPrimaryBorderHover: '#5a5ba8',
      colorPrimaryBorderActive: '#3a3b7a',
      colorBgContainer: '#ffffff',
      colorBorder: '#d9d9d9',
      colorText: '#000000',
      colorTextDisabled: '#00000040',
      colorBgContainerDisabled: '#f5f5f5',
      colorBorderDisabled: '#d9d9d9',
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 24,
      paddingInline: 15,
      paddingInlineLG: 15,
      paddingInlineSM: 7,
    },
    Dropdown: {
      colorBgElevated: '#ffffff',
      colorBgContainer: '#ffffff',
      colorBorderSecondary: '#f0f0f0',
      colorText: '#000000',
      colorTextDescription: '#00000073',
      colorItemBg: '#ffffff',
      colorItemBgHover: '#f5f5f5',
      colorItemBgSelected: '#e6f4ff',
      colorItemText: '#000000',
      colorItemTextHover: '#000000',
      colorItemTextSelected: '#1677ff',
      paddingBlock: 5,
      paddingInline: 12,
      borderRadius: 6,
      zIndexPopup: 1050,
    },
    Layout: {
      headerBg: '#22247B',
    },
  },
};

export default lightTheme;
